import { Fragment } from 'react'

import classNames from 'classnames'

import betaDesktopDefault from './images/beta-desktop-default.svg'
import betaDesktopInverted from './images/beta-desktop-inverted.svg'
import betaMobileDefault from './images/beta-mobile-default.svg'
import betaMobileInverted from './images/beta-mobile-inverted.svg'
import desktopDefault from './images/desktop-default.svg'
import desktopInverted from './images/desktop-inverted.svg'
import mobileDefault from './images/mobile-default.svg'
import mobileInverted from './images/mobile-inverted.svg'

export interface Props {
  beta?: boolean
  inverted?: boolean
  forceFull?: boolean
}

const IMAGES = {
  beta: {
    desktop: {
      default: betaDesktopDefault,
      inverted: betaDesktopInverted,
    },
    mobile: {
      default: betaMobileDefault,
      inverted: betaMobileInverted,
    },
  },
  default: {
    desktop: {
      default: desktopDefault,
      inverted: desktopInverted,
    },
    mobile: {
      default: mobileDefault,
      inverted: mobileInverted,
    },
  },
}

const Logo = ({ beta = false, inverted = false, forceFull = false }: Props) => {
  const prefix = beta ? 'beta' : 'default'
  const suffix = inverted ? 'inverted' : 'default'

  return (
    <Fragment>
      <img
        alt="Taylora"
        className={classNames('h-10', forceFull ? 'block' : 'hidden sm:block')}
        src={IMAGES[prefix].desktop[suffix].src}
      />
      {!forceFull && (
        <img
          alt="Taylora"
          className="block h-10 sm:hidden"
          src={IMAGES[prefix].mobile[suffix].src}
        />
      )}
    </Fragment>
  )
}

export default Logo
